import { IArtifactComponentProps } from "types/services";
import { IRoomPropertyDetailsArtifact } from "types/artifacts/room-property-details";
import { IPropertyId } from "types/artifacts/common";
import { ExteriorOrInteriorOrRoomCard } from "components/ExteriorOrInteriorOrRoomCard";
import { findArtifactByHarid, haridMatches } from "utils/helpers";
import { isProduction } from "scripts/application/setting";

export type IRoomPropertyDetailsOutputProps = IArtifactComponentProps<
    IPropertyId,
    IRoomPropertyDetailsArtifact
>;

RoomPropertyDetailsOutput.artifactKey = "property_detail";
export function RoomPropertyDetailsOutput(props: IRoomPropertyDetailsOutputProps): JSX.Element {
    const { harid, artifacts = [] } = props;

    // if there is no valid artifacts return from the backend
    if (!Array.isArray(artifacts)) return <></>;

    if (harid) {
        const artifactsCount = artifacts.length;
        const artifact = artifactsCount > 1 ? artifacts.find((x) => haridMatches(x.harid, harid) && (x?.select_fields && Array.isArray(x?.select_fields) ? x.select_fields : [])[0] === "rooms") : findArtifactByHarid(artifacts, harid);
        const rooms = artifact?.response?.rooms;
        if (artifact && rooms) {
            return (
                <div style={{ width: '98%' }} className="mb-md-4 mb-3 without-ad">
                    <h2>Rooms</h2>
                    <ExteriorOrInteriorOrRoomCard data={rooms?.items} />
                </div>
            );
        }

        console.error(
            "No artifact or rooms found for 'RoomPropertyDetailsOutput' with the given harid:",
            harid
        );

        return <></>;
    }

    console.error(
        "No harid provided for 'RoomPropertyDetailsOutput'."
    );

    return <></>;
}

RoomPropertyDetailsOutput.asText = function (props: IRoomPropertyDetailsOutputProps): string {
    // console.log("RoomPropertyDetailsOutput.asText", props);
    return props?.artifacts && props.artifacts.length > 0 ? props.artifacts[0]?.response?.rooms?.artifact_text || "" : isProduction ? "" : "RoomPropertyDetailsOutput asText Not Implemented!";
}
